export interface AttachmentPayload {
  name: string;
  ref: string;
  referenceId: string;
}

export class Attachment {


  constructor(private _file: File | string, private _isLoading?: boolean, private _isFailed?: boolean, private _ref?: string, private _referenceId?: string, private _name?: string) {
  }

  getAttachmentPayload(): AttachmentPayload {
    return {name: this._name, ref: this._ref, referenceId: this._referenceId};
  }

  get file(): File | string {
    return this._file;
  }

  set file(value: File | string) {
    this._file = value;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  set isLoading(value: boolean) {
    this._isLoading = value;
  }

  get isFailed(): boolean {
    return this._isFailed;
  }

  set isFailed(value: boolean) {
    this._isFailed = value;
  }

  get ref(): string {
    return this._ref;
  }

  set ref(value: string) {
    this._ref = value;
  }

  get referenceId(): string {
    return this._referenceId;
  }

  set referenceId(value: string) {
    this._referenceId = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  public isAvailable(): boolean {
    return !(this.isLoading || this.isFailed);
  }

  public getAttachmentName(): string {
    return typeof this.file === "string" ? this.name : this.file.name;
  }

  public setAttachmentPayload(data: AttachmentPayload) {
    if (data) {
      this.ref = data.referenceId;
      this.referenceId = data.referenceId;
      this.name = data.name;
    }
  }

  public startUpload() {
    this.isLoading = true;
    this.isFailed = false;
  }

  public setUploadFailed() {
    this.isFailed = true;
    this.isLoading = false;
  }
}
